import { BaseModel, RecursivePartial } from '@models/base';

export class ParamsFilterField extends BaseModel {
    field!: string;
    value: any;
    operator: '=' | '!=' | '>' | '<' | '>=' | '<=' = '=';

    _id?: string;
    _error?: string;

    constructor(json?: RecursivePartial<ParamsFilterField>) {
        super(json);
        this.parseParamsFilterField(json || {});
    }

    parse(json: RecursivePartial<ParamsFilterField>): ParamsFilterField {
        super.parse(json);
        this.parseParamsFilterField(json);
        return this;
    }

    private parseParamsFilterField(json: RecursivePartial<ParamsFilterField>): void {
        ParamsFilterField.assignFields(this, json, ['field', 'value', 'operator'], true);
    }
}
